import type { RosterSettings, ScholarshipPlayer } from '../../../../types/scholarships';
import { tourAnchor } from '../../../tours/tourAnchors';
import { countPitchShapes } from './pitchingStaffSummary';
import { pitchShapeLabel } from './rosterPalette';

interface Props {
  staff: ScholarshipPlayer[];
  settings: RosterSettings;
  /** What the board calls its settings dialog, for the empty-state hint. */
  configureLabel?: string;
}

/** How many pitchers on the staff (RHP + LHP) throw each pitch shape, zeros included. */
export const PitchTypeTotals = ({ staff, settings, configureLabel = 'Configure roster' }: Props) => {
  const totals = countPitchShapes(staff, settings.pitchShapes);
  return (
    <section
      className="pitch-totals"
      aria-labelledby="pitch-totals-heading"
      {...tourAnchor('rosters.pitching.totals')}
    >
      <h2 id="pitch-totals-heading" className="pitch-totals__title">
        Pitch type totals (RHP + LHP)
      </h2>
      {totals.length === 0 ? (
        <p className="pitch-totals__empty">No pitch shapes set up. Add them in {configureLabel}.</p>
      ) : (
        <dl className="pitch-totals__list">
          {totals.map(({ shape, count }) => (
            <div
              key={shape}
              className={`pitch-totals__item${count === 0 ? ' pitch-totals__item--zero' : ''}`}
            >
              <dt className="pitch-totals__shape" title={pitchShapeLabel(shape)}>
                {shape}
              </dt>
              <dd className="pitch-totals__count">{count}</dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  );
};
